/**
 * Clientes - espelho dos Tenants do Auth (spec 0003, req. 11).
 *
 * Nao ha edicao livre, e isso e regra, nao omissao: identidade vive no Auth (regra 3 do
 * workspace). O que existe e ressincronizar - repuxar nome, slug e status de la. Por isso o
 * catalogo de campos aqui nao tem nenhum `edicao`.
 */

import { useQuery } from '@tanstack/react-query'

import { fetchClients } from '../api/catalog'
import { RESOURCE_CATALOGO } from '../api/types'
import type { Client } from '../api/types'
import { usePermissoes } from '../auth/permissoes'
import type { CampoMeta } from '../listagem/campos'
import { IdCurto, Listagem, Marca } from '../listagem/Listagem'
import { Resultado } from '../listagem/Resultado'

const CAMPOS: Array<CampoMeta<Client>> = [
  { nome: 'name', rotulo: 'Nome', grupo: 'Identificação' },
  { nome: 'slug', rotulo: 'Slug', grupo: 'Identificação', formato: 'codigo' },
  {
    nome: 'status',
    rotulo: 'Status',
    grupo: 'Identificação',
    exibir: (item) => <Marca valor={item.status} />,
    nota: 'Vem do Auth. Para mudar, mude lá e ressincronize.',
  },
  {
    nome: 'auth_tenant_id',
    rotulo: 'Tenant no Auth',
    grupo: 'Vínculo',
    formato: 'identificador',
    nota: 'O tenant espelhado por este cliente. É a raiz de tudo que pertence a ele.',
  },
  { nome: 'id', rotulo: 'Identificador no catálogo', grupo: 'Registro', formato: 'identificador' },
]

export function ClientesPage() {
  const { pode } = usePermissoes()
  const consulta = useQuery({ queryKey: ['clients'], queryFn: fetchClients })

  return (
    <>
      <Resultado consulta={consulta}>
        {(clientes) => (
          <Listagem<Client>
            itens={clientes}
            chave="clients"
            entidade="clients"
            rotulo="cliente"
            campos={CAMPOS}
            podeGerenciar={pode(RESOURCE_CATALOGO, 'manage')}
            idDe={(item) => item.id}
            nomeDe={(item) => item.name}
            ressincroniza
            colunas={[
              { titulo: 'Nome', valor: (item) => item.name },
              { titulo: 'Slug', valor: (item) => <code>{item.slug}</code> },
              { titulo: 'Tenant no Auth', valor: (item) => <IdCurto valor={item.auth_tenant_id} /> },
              { titulo: 'Status', valor: (item) => <Marca valor={item.status} /> },
            ]}
            vazio="Nenhum cliente mapeado. O mapeamento é feito no onboarding, passo 1."
          />
        )}
      </Resultado>
    </>
  )
}
